
import React, { useEffect, useState } from 'react'
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, DotsHorizontalIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import AccountServices from '../../services/AccountServices';
import Paginate from '../../utils/Paginate';
import { convert, formatDate, pascalCASE } from './../../utils/convertDate';
import DatePicker from 'react-date-picker';



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
const statusStyles = {
  Approved: 'bg-green-500 text-white',
  Rejected: 'bg-orange-600 text-white',
  Pending: 'bg-amber-400 text-white'
}

export default function MinorAccounts() {

  const [accounts, setAccount] = useState([])
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0)
  const [nextPage, setNextPage] = useState(false)
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("")
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date()
  })
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [status, setStatus] = useState("")

  const listMinor = async (search, from, to, status) => {
    const account = await AccountServices.listMinor(pageIndex, 10, search, from, to, status);
    setAccount([...account.data.result]);
    setPageLength([...account.data.result].length)
    setPageNumber(account.data.totalCount)
    setPageIndex(account.data.pageIndex)
    setPrev(account.data.hasPreviousPage);
    setPage(account.data.totalPages)
    setNextPage(account.data.hasNextPage)
  }

  const searchAccount = async (text) => {
     setSearch(text);
  };

  const handleStatus = async (text) => {
    text = text === "All" ? "" : text;
    setStatus(text);
    listMinor(search, fromm, too, text); 
  }

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from)
    setFrom(formValues.from)
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to)
    setToo(convert(toDate));

   listMinor(search, convert(newDate), convert(toDate), status);
  
  }
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event })
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event })
    }
  };
  const handleExport = async () => {
    const resp = await AccountServices.exportMinor(search, fromm, too, status);
    window.open(resp.data);
  }
  useEffect(() => {
    listMinor(search, fromm, too, status);
  }, [pageIndex]);
  return (<>
    <Layout title="Minor Accounts" pageTag={'account'} current={'/minor/accounts'}>
      <React.Fragment>
        <main>
          <div className='max-w-7xl mx-auto '>
            <div className=''>
              <div className="">
                <div className="mt-5 sm:ml-16 flex justify-end">
                  <button
                    type="button"
                    onClick={handleExport}
                    className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent hover:text-white btn-green px-3 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                    Export CSV
                  </button>
                </div>
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex">
                    <div className='flex'>
                    

                    </div>

                   
                    <div className=" relative rounded-md shadow-sm ml-3">
                      <p className='text-sm leading-3 text-gray-500'>From</p>
                      <div>
                        <DatePicker
                          onChange={dateValidation.fromHandler}
                          value={formValues.from} />
                      </div>
                    </div>
                    <div className=" relative rounded-md shadow-sm ml-3">
                      <p className='text-sm leading-3 text-gray-500'>To</p>
                      <div>
                        <DatePicker
                          onChange={dateValidation.toHandler}
                          value={formValues.to} />
                      </div>
                    </div>
                    <div className="mt-5 ml-3 relative rounded-md shadow-sm">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input
                          type="text"
                          name="user"
                          id="user"
                          onChange={(e) => searchAccount(e.target.value)}
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-8 sm:text-sm border-gray-300 rounded-md"
                          placeholder="Search account"
                        />
                        <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                          <div className='tooltip'>
                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                            <span className="tooltiptext"> <p>Search by Minor's name, parent's customer ID, parent's email address and parent's firstname</p></span>
                          </div>
                        </div>
                      </div>
                    <div className='mt-5 ml-4'>
                      <button
                        onClick={range}
                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                    </div>
                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                      <select
                        id="currency"
                        name="currency"
                        onChange={(e) => handleStatus(e.target.value)}
                        placeholder="Filter by"
                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                      >
                        <option value={"All"}>Filter by</option>
                        <option value={"All"}>All</option>
                        <option value={"Pending"}>Pending</option>
                        <option value={"Approved"}>Approved</option>
                        <option value={"Rejected"}>Rejected</option>
                      </select>
                    </div>
                  </div>
                </div>
                {accounts.length === 0 ?
                  (
                    <div className="mt-8"> No data available for these dates to show. </div>
                  ) : 
                  <>
                  <div className="mt-8 flex ">
                    <div className="-my-2  overflow-x-auto ">
                      <div className="inline-block min-w-full py-2 align-middle mb-20 ">
                        <div className="relative h-screen  ring-black ring-opacity-5 md:rounded-lg">
                          <table className="min-w-full table-fixed divide-y divide-gray-300">
                            <thead>
                              <tr>
                                <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                  Parent Customer ID
                                </th>
                                <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                  Minor's Account Name
                                </th>
                                <th scope="col" className="min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-500">
                                  Minor's Gender
                                </th>
                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                  Minor's Account Status
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                  Minor's Date of Birth
                                </th>
                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                  Minor's Mother's Maiden Name
                                </th>
                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                  Creation Date
                                </th>

                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                  <span className="sr-only">Edit</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                              {accounts.map((person, i) => (
                                <tr key={i} className="bg-gray-50">
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.parentCustomerNumber} </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{pascalCASE(person.firstName)} {person.lastName} </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.gender}</td>
                                  <td>
                                    <span className={classNames(statusStyles[person.accountStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.accountStatus}</span>
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{convert(person.dateofBirth)}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.motherMaidenName}</td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>
                                  <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" value={person.id}>
                                    <Menu as="div" className="ml-3  flex-shrink-0">
                                      <div>
                                        <Menu.Button className="  flex text-sm text-white">
                                          <span className="sr-only">Open user menu</span>
                                          <DotsHorizontalIcon className='w-8 text-gray-400' />
                                        </Menu.Button>
                                      </div>
                                      <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                      >
                                        <Menu.Items className="origin-top-right absolute right-6 mt-2 w-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                          <Link to={`/view/minor?id=${person.id}`} className="block py-2 px-5 text-sm text-gray-700 text-left">
                                            View Account
                                          </Link>

                                        </Menu.Items>
                                      </Transition>
                                    </Menu>

                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Paginate
                    nextPage={nextPage}
                    pageIndex={pageIndex}
                    totalCount={pageNumber}
                    totalPages={totalPage}
                    prevPage={prevPage}
                    setPageIndex={setPageIndex}
                />
                    
                  </>
                  }
            

              </div>

            </div>
          </div>
        </main>

      </React.Fragment>
    </Layout>



  </>);
}